import { React, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Schmerzzeichnung from './Schmerzzeichnung';
import { Button, TextAreaField } from '@aws-amplify/ui-react';
import YesNo from '../anamnese_lib/YesNo';
import { typedReturnValue } from '../anamnese_lib/validateInteger'
import Modal from 'react-bootstrap/Modal';


const JetzigeBeschwerden = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const readOnlyID = "svgreadonly";

    const handleChange = (e) => {
        if (e.schmerzliste) {
            props.handleChange(e);
            return;
        }
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    return (
        <>
            <h4>1.1 Jetzige Beschwerden</h4>
            <h5>Geben Sie bitte die aktuellen Beschwerden an.</h5>
            <TextAreaField
                name="BESCHW"
                width="100%"
                defaultValue={daten.BESCHW}
                onChange={handleChange}
                descriptiveText=""
                placeholder="mehrzeiliges Eingabefeld für aktuelle Beschwerden"
                aria-label="mehrzeiliges Eingabefeld für aktuelle Beschwerden"
                isRequired={true}
                wrap="nowrap"
                maxLength={512}
                rows={3}
                readOnly={props.readOnly}
            />
            <p></p>
            <h5>Haben Sie derzeit Schmerzen?</h5>
            <YesNo
                name="SCHM_YN"
                value={daten.SCHM_YN}
                onChange={handleChange}
                readOnly={props.readOnly}
                aria-label="Wählen Sie aus, ob Sie Schmerzen haben, oder nicht. Bei der Auswahl 'ja' wird die Schema-Zeichnung zur Auswahl der schmerzenden Regionen eingeblendet."
            />
            <p></p>
            {daten.SCHM_YN === 1 &&
                <>
                    <Button variation="secondary" onClick={handleShow}>
                    <Schmerzzeichnung onChange={handleChange} readOnly={true} id={readOnlyID} secondaryid={null} width={80} height={80}/>
                        Schmerzzeichnung<br />&nbsp;anzeigen /&nbsp;bearbeiten
                    </Button>
                    <Modal show={show} fullscreen={true} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Schmerzzeichnung</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Schmerzzeichnung onChange={handleChange} readOnly={props.readOnly} id="svgcontent" secondaryid={readOnlyID} width={1024} height={1024}/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variation="primary" onClick={handleClose}>
                                Schliessen
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            }
        </>
    )
}

export default JetzigeBeschwerden;